export default __webpack_public_path__ + "static/media/close.8f3d623a.svg";